import React from "react";
import { withStyles } from "@material-ui/styles";

import Grid from "@material-ui/core/Grid";

import { getProfileTypeIcon } from "../../../utils/profile";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";

const styles = {
  pictureContainer: {
    width: "77px",
    minWidth: "77px",
    height: "77px",
    border: `1px solid ${colors.veryLighPink}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "10px",
  },
};

const ProfileMatchExpressUnknown = (props) => {
  const { classes, type } = props;

  return (
    <Grid
      item
      xs
      style={{
        padding: "10px",
        borderRadius: "2px",
        backgroundColor: colors.lightGrey,
        ...props.style,
      }}
      className={props.className}
      onClick={props.onClick}
    >
      <Grid container wrap="nowrap">
        <Grid
          item
          className={classes.pictureContainer}
          style={{ backgroundColor: colors.mediumGrey }}
        >
          <img src={images.unknownIconGrey} width="50px" alt="human" />
        </Grid>
        <Grid item xs>
          <Grid container direction="column">
            <Grid item>
              <Grid container>
                <Grid item style={{ paddingRight: "5px" }}>
                  <img
                    src={getProfileTypeIcon(type)}
                    height={"12px"}
                    alt="profile_icon"
                  />
                </Grid>
                <Grid item xs className="bold-500 text-87">
                  {"?"}
                </Grid>
                {props.topRightNode && <Grid item>{props.topRightNode}</Grid>}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(ProfileMatchExpressUnknown);
